module.exports = __webpack_public_path__ + "img/bar-chart-12.92d275d6.svg";